import type { QueryClient } from "@tanstack/react-query";
import { setCachedUserRole } from "@/lib/navCache";

/**
 * Call immediately after `claim_org_admin_role` succeeds.
 *
 * `useUserRole` caches the role two ways, both of which outlive the promotion:
 *   - a React Query entry keyed on the user id, with `staleTime: 1 hour`
 *   - `navCache` in localStorage, used as `placeholderData` for instant paints
 *     and cleared only on sign-out
 *
 * Redeeming the invite token is the one moment a user's role changes mid-session,
 * so without this the client can keep reporting the pre-promotion role — which
 * `ProtectedRoute` then uses to route an org admin as if they were an agent.
 *
 * Both caches are updated rather than just invalidated: the DB write has already
 * committed, so "admin" is known-correct and seeding it avoids a paint where the
 * user is briefly routed on a stale value while the refetch is in flight.
 */
export function markPromotedToAdmin(queryClient: QueryClient) {
  setCachedUserRole("admin");
  queryClient.invalidateQueries({ queryKey: ["user-role"] });
}
